module.exports = __webpack_public_path__ + "img/icon_name.7ad31f3b.png";